// extracted by mini-css-extract-plugin
export var card = "schedule-card-module--card--xSRD4";
export var cardTitle = "schedule-card-module--card-title--1bhDb";
export var dates = "schedule-card-module--dates--s4oed";
export var body = "schedule-card-module--body--3K7oS";
export var divider = "schedule-card-module--divider--2Y7Xj";
export var date = "schedule-card-module--date--2jabT";
export var day = "schedule-card-module--day--27Dse";
export var small = "schedule-card-module--small--2sPIe";
export var badges = "schedule-card-module--badges--2xKsT";